<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import moment from 'moment'

export default {
    data() {
        return {
            showShipmentStatusDialog: false,
            id: '',
            info: {}
        };
    },
    methods: {
        init() {
            this.id = this.$route.query.id
            this.getExchangeDetail()
        },
        async getExchangeDetail() {
            const data = await this.api.getExchangeDetail({
                access_token: localStorage.getItem("access_token"),
                exchangeId: this.id  
            })

            data.isCancel = moment().isBefore(data.deadlineCancleShippingTime)
            this.info = data
        },
        statusChange() {
            this.getExchangeDetail()
        },
        async setStatus() {
            if(this.info.status === '0') {
                this.showShipmentStatusDialog = true
            }else {
                await this.api.setShipping({
                    access_token: localStorage.getItem("access_token"),
                    exchangeId: this.id,
                    type: 2
                })

                this.$message({ type: 'success', message: '已设为"待发货"状态' })
                this.statusChange()
            }
        }
    },
    created() {
        this.init()
    },
};
</script>
